



































































































































































































































































import Vue from 'vue';
import moment from 'moment';

import { EventBus } from '@/event-bus';
import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { SpecialInstructionRecord } from '@/models/specialInstructions/SpecialInstructionRecord';
import { SpecialInstructionSearchOptions } from '@/models/specialInstructions/SpecialInstructionSearchOptions';
import SaveSpecialInstructionRequest from '@/models/specialInstructions/SaveSpecialInstructionRequest';

import compareService from '@/services/CompareService';
import exportService from '@/services/ExportService';
import specialInstructionsService from '@/services/SpecialInstructionsService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      pageSize: 10,
      term: '',
      currentInstructionId: '',
      loading: false as Boolean,
      deleting: false as Boolean,
      editing: false as Boolean,
      displayInstructionForm: false as Boolean,
      displayConfirmDelete: false as Boolean,
      headers: [
        { text: '', sortable: false, value: 'id' },
        {
          text: 'Type',
          sortable: true,
          value: 'type',
          class: 'special-inst-header',
        },
        {
          text: 'Title',
          sortable: true,
          value: 'title',
          width: '200px',
        },
        {
          text: 'Message',
          sortable: true,
          value: 'message',
          width: '300px',
        },
        {
          text: 'Active Date Range',
          sortable: true,
          value: 'startDate',
          class: 'special-inst-range',
        },
        {
          text: 'Applies to Entire Account',
          sortable: true,
          value: 'accountWide',
          class: 'special-inst-account',
        },
      ],
      page: [] as Array<SpecialInstructionRecord>,
      instructions: [] as SpecialInstructionRecord[],
    };
  },
  created() {
    this.search();
  },
  methods: {
    pageChange(newPage: number) {
      this.page = this.instructions.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
    },
    edit(id) {
      this.currentInstructionId = id;
      this.editing = true;
      specialInstructionsService.getById(id).then((x) => {
        const instruction = new SaveSpecialInstructionRequest();
        instruction.id = x.id;
        instruction.type = x.type;
        instruction.title = x.title;
        instruction.startDate = moment(x.startDate as any).format('YYYY-MM-DD');
        instruction.endDate = moment(x.endDate as any).format('YYYY-MM-DD');
        instruction.message = x.message;
        instruction.accountWide = x.accountWide;
        instruction.userId = x.userId;
        instruction.accountId = x.accountId;

        this.editing = false;
        this.currentInstructionId = null;

        EventBus.$emit('settings-special-inst-edit', instruction);
        this.displayInstructionForm = true;
      });
    },
    search() {
      this.loading = true;
      specialInstructionsService
        .search(
          new SpecialInstructionSearchOptions(
            this.user.accountId,
            this.user.userId,
            this.term
          )
        )
        .then((x: SpecialInstructionRecord[]) => {
          let items = x.sort(compareService.compareById);

          this.instructions = items;
          this.page = items.slice(0, this.pageSize);
          this.loading = false;
        });
    },
    onClear() {
      this.term = null;
      this.search(null);
    },
    exportCsv() {
      exportService.csvDownload(this.instructions, 'Instruction List');
    },
    confirmDelete(instructionId: string) {
      this.currentInstructionId = instructionId;
      this.displayConfirmDelete = true;
    },
    openAddNewInstructionForm() {
      EventBus.$emit('settings-special-inst-create-new');
      this.displayInstructionForm = true;
    },
    softDeleteInstruction() {
      if (this.currentInstructionId) {
        this.deleting = true;
        specialInstructionsService
          .deleteById(this.currentInstructionId)
          .then(() => {
            this.snackbarText = `Your instruction has been deleted.`;
            this.snackbar = true;

            this.search();

            this.displayConfirmDelete = false;
            this.currentInstructionId = null;
            this.deleting = false;
          });
      }
    },
    closeAndReload() {
      this.displayInstructionForm = false;
      this.search();
    },
  },
  computed: {
    addEditDialogWidth() {
      if (this.smAndDown) return '90%';
      if (this.xl) return '35%';

      return '45%';
    },
    showNoData() {
      return !this.loading && (!this.page || !this.page.length);
    },
    showDataGrid() {
      return !this.showNoData;
    },
  },
});
